(function () {
  'use strict';

  /* ── 1. PRODUCT DATA (rendered server-side by Liquid) ──────────── */

  /**
   * All product variants, keyed by Shopify's 3 options:
   *   option1 = Body Style
   *   option2 = Tabletop Style (encodes fuel + finish)
   *   option3 = Firepit Shape
   */
  var FP_VARIANTS = (window.fpProductData && window.fpProductData.variants) ? window.fpProductData.variants : [];

  /**
   * Product images array: [{alt, src}]
   * Used to show body style preview images when available.
   */
  var FP_IMAGES = (window.fpProductData && window.fpProductData.images) ? window.fpProductData.images : [];

  /**
   * Currency formatting helper — reads Shopify's money format if available.
   * Prices come from Liquid as integers (cents).
   */
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.money_format) {
      // Basic Shopify money format substitution
      var amount = (cents / 100).toFixed(2);
      return Shopify.money_format.replace('{{' + 'amount}}', amount)
                                 .replace('{{' + 'amount_no_decimals}}', Math.round(cents / 100))
                                 .replace('{{' + 'amount_with_comma_separator}}', amount.replace('.', ','))
                                 .replace('{{ ' + 'amount }}', amount)
                                 .replace('{{ ' + 'amount_no_decimals }}', Math.round(cents / 100));
    }
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ── 2. STATE ──────────────────────────────────────────────────── */

  /**
   * selections holds the user's choices across all 4 steps.
   * null = not yet chosen.
   */
  var selections = {
    shape:          null,   // "Shape (Square)" | "Shape (Round)"
    bodyStyle:      null,   // "Brickyard" | "Stackstone" | "Limestone" | "Corten Steel"
    fuelType:       null,   // "Gas" | "Wood Burning"
    tabletopFinish: null    // "Limestone" | "Black Granite"
  };

  /** Currently active step number (1–4), or 5 when showing result */
  var currentStep = 1;

  /** Human-readable labels for the summary */
  var STEP_LABELS = {
    shape:          'Shape',
    bodyStyle:      'Body Style',
    fuelType:       'Fuel Type',
    tabletopFinish: 'Tabletop Finish'
  };

  /**
   * Maps a logical step index (1–4) to a selection key.
   * Useful for "change" link wiring.
   */
  var STEP_TO_KEY = {
    1: 'shape',
    2: 'bodyStyle',
    3: 'fuelType',
    4: 'tabletopFinish'
  };

  /**
   * Display labels for selection values shown in the summary.
   */
  var VALUE_LABELS = {
    'Shape (Square)': 'Square',
    'Shape (Round)':  'Round',
    'Gas':            'Gas',
    'Propane':        'Propane',
    'Wood Burning':   'Wood Burning',
    'Limestone':      'Polished Limestone',
    'Black Granite':  'Polished Black Granite'
  };

  /* ── 3. DOM REFERENCES ─────────────────────────────────────────── */

  var wrapper = document.querySelector('[data-fp-selector]');
  var resultPanel  = document.getElementById('fp-result');
  var addToCartBtn = document.getElementById('fp-add-to-cart');
  var restartBtn   = document.getElementById('fp-restart');
  var priceDisplay = document.getElementById('fp-price-display');

  /* ── 4. VARIANT LOOKUP ─────────────────────────────────────────── */

  /**
   * Reconstructs the Shopify Option 2 string (Tabletop Style) from
   * the user's fuelType + tabletopFinish selections.
   *
   * Shopify format examples:
   *   "GFRC Polished Limestone Finish (Gas)"
   *   "GFRC Polished Black Granite Finish (Gas)"
   *   "GFRC Polished Limestone Finish (Wood Burning)"
   *   "GFRC Polished Black Granite Finish (Wood Burning)"
   */
  function buildTabletopStyleString(fuelType, finish) {
    return 'GFRC Polished ' + finish + ' Finish (' + fuelType + ')';
  }

  /**
   * Finds the Shopify variant that matches the current selections.
   * Returns null if no match is found.
   */
  function findMatchingVariant() {
    if (!selections.shape || !selections.bodyStyle || !selections.fuelType || !selections.tabletopFinish) {
      return null;
    }

    var tabletopStyle = buildTabletopStyleString(selections.fuelType, selections.tabletopFinish);

    for (var i = 0; i < FP_VARIANTS.length; i++) {
      var v = FP_VARIANTS[i];
      /* option1 = Body Style, option2 = Tabletop Style, option3 = Firepit Shape */
      if (
        v.option1 === selections.bodyStyle &&
        v.option2 === tabletopStyle &&
        v.option3 === selections.shape
      ) {
        return v;
      }
    }
    return null;
  }

  /* ── 5. NATIVE VARIANT INPUT UPDATE ───────────────────────────── */

  /**
   * Updates Shopify's native hidden variant input and fires a change
   * event so the theme's JS (price display, image swap, cart button
   * state) reacts correctly.
   *
   * Targets both the classic #ProductSelect and the newer
   * input[name="id"] patterns used by Online Store 2.0 themes.
   */
  function updateNativeVariantInput(variantId) {
    var selectors = [
      '#ProductSelect',
      '#ProductSelect',
      'input[name="id"][form]',
      'select[name="id"]',
      'input[name="id"]'
    ];

    selectors.forEach(function (sel) {
      try {
        var inputs = document.querySelectorAll(sel);
        inputs.forEach(function (input) {
          input.value = variantId;
          var event = new Event('change', { bubbles: true });
          input.dispatchEvent(event);
        });
      } catch (e) { /* selector may not exist, that's fine */ }
    });

    /* Also update Shopify's global ShopifyAnalytics if present */
    if (typeof ShopifyAnalytics !== 'undefined' && ShopifyAnalytics.lib) {
      try { ShopifyAnalytics.lib.track('Viewed Product Variant', { variantId: variantId }); } catch (e) {}
    }
  }

  /* ── 6. PROGRESS INDICATOR ─────────────────────────────────────── */

  function updateProgressBar(step) {
    wrapper.querySelectorAll('[data-fp-prog-step]').forEach(function (dot) {
      var s = parseInt(dot.getAttribute('data-fp-prog-step'), 10);
      dot.classList.remove('is-active', 'is-complete');
      if (s < step) dot.classList.add('is-complete');
      else if (s === step) dot.classList.add('is-active');
    });
  }

  /* ── 7. SUMMARY RENDERING ──────────────────────────────────────── */

  /**
   * Renders the "steps completed so far" summary strip above a given step.
   * Each completed step shows its label, value, and a "Change" button.
   *
   * @param {HTMLElement} summaryEl - The .fp-summary container to fill
   * @param {number}      upToStep  - Render summaries for steps 1..(upToStep-1)
   */
  function renderSummary(summaryEl, upToStep) {
    if (!summaryEl) return;
    summaryEl.innerHTML = '';

    for (var s = 1; s < upToStep; s++) {
      var key = STEP_TO_KEY[s];
      var val = selections[key];
      if (!val) continue;

      var displayVal = VALUE_LABELS[val] || val;

      var item = document.createElement('div');
      item.className = 'fp-summary__item';
      item.setAttribute('role', 'status');

      var labelEl = document.createElement('span');
      labelEl.className = 'fp-summary__label';
      labelEl.textContent = STEP_LABELS[key];

      var valueEl = document.createElement('span');
      valueEl.className = 'fp-summary__value';
      valueEl.textContent = displayVal;

      var changeBtn = document.createElement('button');
      changeBtn.className = 'fp-summary__change';
      changeBtn.type = 'button';
      changeBtn.textContent = 'Change';
      changeBtn.setAttribute('aria-label', 'Change ' + STEP_LABELS[key]);
      /* Bind the step number via closure */
      (function (stepNum, selectionKey) {
        changeBtn.addEventListener('click', function () {
          goToStep(stepNum, selectionKey);
        });
      })(s, key);

      item.appendChild(labelEl);
      item.appendChild(valueEl);
      item.appendChild(changeBtn);
      summaryEl.appendChild(item);
    }
  }

  /* ── 8. STEP NAVIGATION ────────────────────────────────────────── */

  /**
   * Navigates to a specific step.
   * When going back (changeKey provided), clears that selection and
   * all subsequent ones.
   *
   * @param {number} step      - Target step number (1–4)
   * @param {string} [changeKey] - Selection key to clear when going back
   */
  function goToStep(step, changeKey) {
    /* Clear the changed selection and all subsequent ones */
    if (changeKey) {
      var keys = Object.keys(selections);
      var startIdx = keys.indexOf(changeKey);
      for (var i = startIdx; i < keys.length; i++) {
        selections[keys[i]] = null;
      }
    }

    currentStep = step;

    /* Hide result panel */
    resultPanel.classList.remove('is-active');

    /* Show/hide steps */
    wrapper.querySelectorAll('[data-fp-step]').forEach(function (el) {
      var s = parseInt(el.getAttribute('data-fp-step'), 10);
      el.classList.toggle('is-active', s === step);
    });

    /* Render summaries for the target step */
    var summaryEl = document.getElementById('fp-summary-' + step);
    if (summaryEl) renderSummary(summaryEl, step);

    /* Sync option button states for the current step */
    syncOptionStates(step);

    /* Update progress bar */
    updateProgressBar(step);

    /* Scroll selector into view smoothly */
    wrapper.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  /**
   * Syncs the is-selected state of option buttons on a given step
   * to match the current selections state. Also updates aria-pressed.
   */
  function syncOptionStates(step) {
    var key = STEP_TO_KEY[step];
    var currentVal = selections[key];

    wrapper.querySelectorAll('[data-fp-choice="' + key + '"]').forEach(function (btn) {
      var val = btn.getAttribute('data-fp-value');
      var selected = (val === currentVal);
      btn.classList.toggle('is-selected', selected);
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  /* ── 9. BODY STYLE IMAGES ──────────────────────────────────────── */

  /**
   * Attempts to inject product images into body style cards.
   * Matches by looking for product images whose alt text contains
   * the body style name (case-insensitive).
   *
   * Falls back gracefully to text-only cards if no image is found.
   */
  function injectBodyStyleImages() {
    var bodyStyleCards = {
      'Brickyard':    { desc: 'Textured brick pattern' },
      'Stackstone':   { desc: 'Layered stone texture' },
      'Limestone':    { desc: 'Smooth natural finish' },
      'Corten Steel': { desc: 'Weathered industrial patina' }
    };

    wrapper.querySelectorAll('[data-fp-choice="bodyStyle"]').forEach(function (btn) {
      var val = btn.getAttribute('data-fp-value');
      var info = bodyStyleCards[val];
      if (!info) return;

      /* Find a matching product image */
      var matchedImage = null;
      for (var i = 0; i < FP_IMAGES.length; i++) {
        var img = FP_IMAGES[i];
        if (img.alt && img.alt.toLowerCase().indexOf(val.toLowerCase()) !== -1) {
          matchedImage = img;
          break;
        }
      }

      if (matchedImage) {
        /* Rebuild card with image */
        btn.innerHTML =
          '<div class="fp-option__image-wrap">' +
            '<img src="' + matchedImage.src + '" alt="' + val + ' body style" loading="lazy">' +
          '</div>' +
          '<div class="fp-option__check" aria-hidden="true">✓</div>' +
          '<div class="fp-option__name">' + val + '</div>';
      }
      /* else: keep the existing text-only card as-is */
    });
  }

  /* ── 10. RESULT PANEL ──────────────────────────────────────────── */

  function showResult() {
    /* Identify matching variant */
    var variant = findMatchingVariant();

    /* Update result card rows */
    document.getElementById('fp-result-shape').textContent  = VALUE_LABELS[selections.shape]  || selections.shape  || '—';
    document.getElementById('fp-result-body').textContent   = selections.bodyStyle  || '—';
    document.getElementById('fp-result-fuel').textContent   = selections.fuelType   || '—';
    document.getElementById('fp-result-finish').textContent = VALUE_LABELS[selections.tabletopFinish] || selections.tabletopFinish || '—';

    /* Update summary above result */
    var resultSummary = document.getElementById('fp-summary-result');
    if (resultSummary) renderSummary(resultSummary, 5); /* "5" = render all 4 steps */

    if (variant) {
      /* Price */
      priceDisplay.innerHTML = formatMoney(variant.price) + ' <span>USD</span>';

      /* Discount callout */
      var discountNote = document.getElementById('fp-discount-note');
      if (discountNote) { discountNote.style.display = 'flex'; }

      /* Add to Cart button */
      if (variant.available) {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove('is-sold-out');
        addToCartBtn.textContent = 'Add to Cart';
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('is-sold-out');
        addToCartBtn.textContent = 'Sold Out';
      }

      /* Update native Shopify variant input */
      updateNativeVariantInput(variant.id);

    } else {
      /* Combination not found or unavailable */
      priceDisplay.innerHTML = '<span>Combination unavailable</span>';
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add('is-sold-out');
      addToCartBtn.textContent = 'Unavailable';
    }

    /* Hide all steps, show result */
    wrapper.querySelectorAll('[data-fp-step]').forEach(function (el) {
      el.classList.remove('is-active');
    });
    resultPanel.classList.add('is-active');

    /* Progress bar: all steps complete */
    updateProgressBar(5);

    wrapper.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  /* ── 11. ADD TO CART ───────────────────────────────────────────── */

  addToCartBtn.addEventListener('click', function () {
    var variant = findMatchingVariant();
    if (!variant || !variant.available) return;

    /* If there's a product form on the page, submit it */
    var productForm =
      document.querySelector('form[action="/cart/add"]') ||
      document.querySelector('#product-form') ||
      document.querySelector('form[action="/cart/add"]') ||
      document.querySelector('.product-form form') ||
      document.querySelector('[data-type="add-to-cart-form"]');

    if (productForm) {
      /* Ensure the variant ID is set before submission */
      updateNativeVariantInput(variant.id);

      /* Short delay to let any theme JS react to the change event */
      setTimeout(function () {
        /* Try to find and click the theme's native ATC button if it's hidden */
        var nativeBtn = productForm.querySelector('[name="add"]') ||
                        productForm.querySelector('[data-add-to-cart]') ||
                        productForm.querySelector('button[type="submit"]');
        if (nativeBtn && !nativeBtn.disabled) {
          nativeBtn.click();
        } else {
          /* Fall back: submit the form directly */
          productForm.submit();
        }
      }, 100);

    } else {
      /* No form found — direct cart add via fetch (fallback) */
      addToCartBtn.classList.add('is-loading');
      addToCartBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        addToCartBtn.classList.remove('is-loading');
        addToCartBtn.textContent = 'Added!';
        /* Trigger cart drawer/count update for Be Yours theme */
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        setTimeout(function () {
          addToCartBtn.textContent = 'Add to Cart';
        }, 2000);
      })
      .catch(function () {
        addToCartBtn.classList.remove('is-loading');
        addToCartBtn.textContent = 'Error — Try Again';
        setTimeout(function () {
          addToCartBtn.textContent = 'Add to Cart';
        }, 2500);
      });
    }
  });

  /* ── 12. RESTART ───────────────────────────────────────────────── */

  restartBtn.addEventListener('click', function () {
    selections = { shape: null, bodyStyle: null, fuelType: null, tabletopFinish: null };
    goToStep(1);
    resultPanel.classList.remove('is-active');
    wrapper.querySelectorAll('[data-fp-step]').forEach(function (el) {
      el.classList.remove('is-active');
    });
    wrapper.querySelector('[data-fp-step="1"]').classList.add('is-active');
  });

  /* ── 13. OPTION BUTTON CLICK HANDLER ──────────────────────────── */

  /**
   * Delegated click handler on the wrapper — handles all option button
   * selections in one place.
   */
  wrapper.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fp-choice]');
    if (!btn) return;

    var choice = btn.getAttribute('data-fp-choice');
    var value  = btn.getAttribute('data-fp-value');

    if (btn.classList.contains('is-unavailable')) return;

    /* Store selection */
    selections[choice] = value;

    /* Update aria-pressed on sibling buttons */
    wrapper.querySelectorAll('[data-fp-choice="' + choice + '"]').forEach(function (b) {
      b.classList.toggle('is-selected', b === btn);
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });

    /* Advance to next step (with a brief visual pause for feedback) */
    setTimeout(function () {
      var nextStep = currentStep + 1;
      if (nextStep <= 4) {
        goToStep(nextStep);
      } else {
        /* All 4 steps complete — show result */
        showResult();
      }
    }, 220);
  });

  /* ── 14. HIDE NATIVE SELECTORS ─────────────────────────────────── */

  /**
   * Applies data-fp-hide-native to the correct ancestor so the CSS
   * rule hides the theme's built-in variant inputs.
   *
   * Be Yours theme typically wraps variant selectors in:
   *   .product-form__input, variant-selects, variant-radios
   *
   * We walk up from our wrapper and mark the product section root.
   */
  function hideNativeSelectors() {
    /* Try to find the Be Yours section container */
    var sectionEl =
      wrapper.closest('.shopify-section') ||
      wrapper.closest('[id^="shopify-section-"]') ||
      wrapper.closest('.shopify-section') ||
      wrapper.closest('.product') ||
      document.body;

    if (sectionEl) {
      sectionEl.setAttribute('data-fp-hide-native', '');
    }

    /* Also directly hide any we can find in the DOM */
    var nativeSelectors = [
      'variant-selects',
      'variant-radios',
      '.product-form__input',
      '.variant-selects',
      '.variant-radios'
    ];
    nativeSelectors.forEach(function (sel) {
      try {
        document.querySelectorAll(sel).forEach(function (el) {
          if (!el.closest('[data-fp-selector]')) {
            el.style.display = 'none';
          }
        });
      } catch (e) {}
    });
  }

  /* ── 15. INITIALISE ────────────────────────────────────────────── */

  function init() {
    hideNativeSelectors();
    injectBodyStyleImages();
    updateProgressBar(1);

    /* Ensure step 1 is the only active step on load */
    wrapper.querySelectorAll('[data-fp-step]').forEach(function (el) {
      el.classList.remove('is-active');
    });
    wrapper.querySelector('[data-fp-step="1"]').classList.add('is-active');
    resultPanel.classList.remove('is-active');
  }

  /* Run after DOM is ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();